import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.scss';
import Assign from 'components/Operational/asyncAssignDropdown';

const AssignPersonnelAsync = ({
  assignHandler,
  options,
  event,
  optionLabelKey = 'label',
  fetchFilters = {},
  dataTransform,
  onChangeCallback,
  fetchOptions,
}) => {
  const [selectedEventAssignee, setSelectedEventAssignee] = useState();

  const fetchInitialData = useCallback(() => {
    event?.others?.assigneeId.value && // do not set id and label unless you have a value
      event?.others?.assignee.value &&
      setSelectedEventAssignee({
        id: event.others.assigneeId.value,
        label: event.others.assignee.value,
      });
  }, [event]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const onClickAssign = () => {
    assignHandler(selectedEventAssignee);
  };
  return (
    <div className={styles.operationalPanel}>
      <Assign
        label="Assign New"
        placeholder="Select Personnel"
        options={options}
        selectedValue={selectedEventAssignee}
        changeSelectedValue={setSelectedEventAssignee}
        btnText={'Assign'}
        btnSize={'s'}
        btnColor={'primary'}
        btnClick={onClickAssign}
        optionLabelKey={optionLabelKey}
        fetchFilters={fetchFilters}
        dataTransform={dataTransform}
        onChangeCallback={onChangeCallback}
        fetchOptions={fetchOptions}
      />
    </div>
  );
};

AssignPersonnelAsync.propTypes = {
  options: PropTypes.array,
  assignHandler: PropTypes.func,
  event: PropTypes.object,
  optionLabelKey: PropTypes.string,
  fetchFilters: PropTypes.object,
  dataTransform: PropTypes.func,
  onChangeCallback: PropTypes.func,
  fetchOptions: PropTypes.func,
};

export default AssignPersonnelAsync;
